export default function ErrorFallback({error, resetErrorBoundary}) {
  return (
    <div className="alert alert-warning" role="alert">
      <strong>Something went wrong!</strong> Please refresh the page
    </div>
  )
}
